import React, { useState, useEffect, forwardRef } from "react";
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import Logo from "../images/logo.png"
import MarginHeader from "./marginHeader";
import MarginContent from './marginContent'
import callingAPI from "../service"
import MarginTable from "./marginTable";
import NonMarginSubContent from "./nonMarginSubContent";
import NonMarginTable from "./nonMarginTable";
import { useSelector } from "react-redux";

const StatementoffinancialholdingsPdf = forwardRef((props, ref) => {
    const reportDetails = useSelector((state) => state.report.marginportfolio);
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const [marginListSummery, setMarginListSummery] = useState([])
    const [clientAddressDetails, setClientAddressDetails] = useState({
        building: "48 Burj Gate",
        street: "Sheikh Zayed Road",
        citya: "Dubai",
        countrya: "United Arab Emirates",
        officeno: "801",
        trnno: "",
        mobile: "919961727479",
        postbox: "119930"
    });
    const [marginListDetails, setMarginListDetails] = useState([])
    const [marginParticularsList, setMarginParticularsList] = useState([])
    const [totalMarketValue_AED, setTotalMarketValue_AED] = useState([])
    const [totalcashBalance_AED, setTotalcashBalance_AED] = useState([])
    const [totalnetAssetValue_AED, setTotalnetAssetValue_AED] = useState([])
    const [particularsMessage1, setParticularsMessage1] = useState("")
    const [particularsMessage2, setParticularsMessage2] = useState("")
    const [grandTotalMarketValueMarginSecurities, setGrandTotalMarketValueMarginSecurities] = useState("")
    const [grandTotalMarginAmount, setGrandTotalMarginAmount] = useState("")
    const [cashBalanceDetails, setCashBalanceDetails] = useState([])
    const refreshToken = dashboardDetails.refreshToken;

    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0]; // Converts to YYYY-MM-DD format
    };
    const [formattedFromDate, setFormattedFromDate] = useState(formatDate(new Date())); // Set default value


    const [formattedToDate, setFormattedToDate] = useState(() =>
        props.toDate ? formatDate(props.toDate) : formatDate(new Date())
    );

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '21cm', // A4 paper height in cm
        width: '100%',
        margin: '0 auto',
        padding: '0 15px 0 15px', // 15px left and right padding, 2cm padding bottom for the footer
        position: 'relative',
        fontFamily: 'Roboto Medium',
        color: '#000',
        fontSize: '13px',
        boxSizing: 'border-box' // Ensures padding doesn't affect the width
    };

    const htmlBodyStyle = {
        width: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden' // Hides horizontal scroll globally
    };

    const headerStyle = {
        // marginBottom: '1cm',
    };

    const mainStyle = {
        flex: '1',
        // marginBottom: '1cm',
    };

    const footerStyle = {
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '2px solid #d5d5d5',
        textAlign: 'center',
        fontSize: '12px',
        padding: '5px',
        position: 'absolute',
        bottom: '-10px',
    };


    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: "4px 5px",
        color: "#000",
        fontSize: '13px',



    }
    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        // padding:"1px",
        fontSize: "13px"
    }
    const total = {
        fontFamily: "Roboto Black",
        fontSize: "13px"
    }
    useEffect(() => {
        // marginReportList();.
        if (props.fromDate) {
            console.log("🚀 ~ useEffect ~ props.fromDate:", props.fromDate)
            setFormattedFromDate(formatDate(props.fromDate)); // Update when props.fromDate changes
        }

        setMarginListSummery(reportDetails?.summery)
        setClientAddressDetails(reportDetails?.clientAddressDetails || clientAddressDetails); // Use dynamic data or fallback to sample
        setMarginListDetails(reportDetails?.details)
        setMarginParticularsList(reportDetails?.marginParticulars)
        setTotalMarketValue_AED(reportDetails?.totalmarketValue_AED)
        setTotalcashBalance_AED(reportDetails?.totalcashBalance_AED)
        setTotalnetAssetValue_AED(reportDetails?.totalnetAssetValue_AED)
        setParticularsMessage1(reportDetails?.particularsMessage1)
        setParticularsMessage2(reportDetails?.particularsMessage2)
        setGrandTotalMarketValueMarginSecurities(reportDetails?.grandTotalMarketValueMarginSecurities)
        setGrandTotalMarginAmount(reportDetails?.grandTotalMarginAmount)
        setCashBalanceDetails(reportDetails?.cashBalanceDetails)
        document.documentElement.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
        document.body.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
    }, [reportDetails]);
    const marginReportList = () => {
        const clientId = dashboardDetails.clientid;
        const userId = dashboardDetails.userId
        const postData = {
            "userId": userId,
            "fromDate": props.fromDate != undefined ? formatDate(props.fromDate) : formatDate(new Date()),
            "toDate": props.fromDate != undefined ? formatDate(props.fromDate) : formatDate(new Date()),
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/getMarginPortfolio", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    const dataValue = data.data
                    setMarginListSummery(dataValue.summery)
                    setClientAddressDetails(dataValue.clientAddressDetails)
                    setMarginListDetails(dataValue.details)
                    setMarginParticularsList(dataValue.marginParticulars)
                    setTotalMarketValue_AED(dataValue.totalmarketValue_AED)
                    setTotalcashBalance_AED(dataValue.totalcashBalance_AED)
                    setTotalnetAssetValue_AED(dataValue.totalnetAssetValue_AED)
                    setParticularsMessage1(dataValue.particularsMessage1)
                    setParticularsMessage2(dataValue.particularsMessage2)
                    setGrandTotalMarketValueMarginSecurities(dataValue.grandTotalMarketValueMarginSecurities)
                    setGrandTotalMarginAmount(dataValue.grandTotalMarginAmount)
                    setCashBalanceDetails(dataValue.cashBalanceDetails)


                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };
    return (
        <div ref={ref} id="pdf-content">
            <div style={containerStyle} ref={ref} id="pdf-content">
                <header style={headerStyle}>
                    <MarginHeader clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                        toDate={formattedToDate} />
                </header>
                <hr />
                <main style={mainStyle}>
                    <MarginContent marginSummery={marginListSummery} totalMarketValue_AED={totalMarketValue_AED} totalcashBalance_AED={totalcashBalance_AED} totalnetAssetValue_AED={totalnetAssetValue_AED} />
                    {/* <MarginContent /> */}
                </main>
                <footer style={footerStyle}>
                    <div style={{ lineHeight: "15px" }}>
                        <div>A Subsidiary of DUBAI INVESTMENTS</div>
                        <div>
                            {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                            Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                        </div>
                        <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                    </div>
                    <div className="pb-2 pt-3" style={{ lineHeight: "15px" }}>
                        <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                        <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                    </div>
                </footer>
            </div>
            <div style={containerStyle} ref={ref} id="pdf-content">
                <header style={headerStyle}>
                    <MarginHeader clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                        toDate={formattedToDate} />
                </header>
                <hr />
                <main style={mainStyle}>
                    <NonMarginSubContent cashBalanceDetails={cashBalanceDetails} marginParticularsList={marginParticularsList} particularsMessage2={particularsMessage2} particularsMessage1={particularsMessage1} />
                </main>
                <footer style={footerStyle}>
                    <div style={{ lineHeight: "15px" }}>
                        <div>A Subsidiary of DUBAI INVESTMENTS</div>
                        <div>
                            {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                            Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                        </div>
                        <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                    </div>
                    <div className="pb-2 pt-3" style={{ lineHeight: "15px" }}>
                        <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                        <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                    </div>
                </footer>
            </div>
            <div >
                <div style={containerStyle} >
                    <footer style={mainStyle}>
                        <NonMarginTable marginDetails={marginListDetails} clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                            toDate={formattedToDate} grandTotalMarketValueMarginSecurities={grandTotalMarketValueMarginSecurities} grandTotalMarginAmount={grandTotalMarginAmount} />
                    </footer>
                </div>
            </div>
            {/* <hr /> */}

        </div>
    )
})
export default StatementoffinancialholdingsPdf;